import React from "react";
import LeftImg from './images/services/facility.jpg'
import Icon01 from './images/services/facility1.png'
import Icon02 from './images/services/facility2.png'
import Icon03 from './images/services/facility3.png'
import Icon04 from './images/services/facility4.png'
import Icon05 from './images/services/facility5.png'
function CustomerInfo() {
  return (
    <section className="image-description-section section">
        <p className="section-heading">Facility Management App for building & facilities issues and asset management.</p>
    <div className="image-description-left image-section-left">
        <img src={LeftImg} alt="Description Image" className="image_description"
        style={{filter:'invert(0)'}}
        />
    </div>
    <div className="image-description-right description">
        <h2 className="heading-underline">Key Features</h2>
        <p className="description-para">
            <img src={Icon01} width={30} height={30} className="img-fluid" alt="icons"/>
           Manage buildings, facilities & assets.</p>
        <p className="description-para">
            <img src={Icon02} width={30} height={30} className="img-fluid" alt="icons"/>
            Add facilities, rooms and assets in app as required. </p>
        <p className="description-para">
            <img src={Icon03} width={30} height={30} className="img-fluid" alt="icons"/>
            Itemize issues and assign to staff. </p>
        <p className="description-para">
            <img src={Icon04} width={30} height={30} className="img-fluid" alt="icons"/>
            Detailed reports and dashboard.</p>
        <p className="description-para">
            <img src={Icon05} width={30} height={30} className="img-fluid" alt="icons"/>
            Full multi-role administration.</p>
    </div>
</section>  
  )
}
export default CustomerInfo;